import React from 'react';
import { Icon, Badge, Button } from './UI';

export function ProgrammeCard({ programme, onClick, showEnrolled, enrolled }) {
  return (
    <div
      onClick={onClick}
      style={{ background: 'var(--white)', border: '1.5px solid var(--dark-10)', borderRadius: 'var(--radius-xl)', padding: 24, cursor: onClick ? 'pointer' : 'default', transition: 'all 0.18s', position: 'relative', overflow: 'hidden' }}
      onMouseEnter={e => { if (onClick) { e.currentTarget.style.borderColor = programme.color; e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(45,48,53,0.1)'; } }}
      onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--dark-10)'; e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
    >
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 4, background: programme.color, borderRadius: '16px 16px 0 0' }} />
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 14 }}>
        <div style={{ width: 46, height: 46, borderRadius: 12, background: programme.color + '18', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Icon name={programme.icon} size={22} color={programme.color} />
        </div>
        {showEnrolled && (
          <Badge
            bg={enrolled ? 'var(--success-soft)' : 'var(--dark-05)'}
            color={enrolled ? 'var(--success)' : 'var(--dark-40)'}
            dot={enrolled}
          >
            {enrolled ? 'Enrolled' : 'Not enrolled'}
          </Badge>
        )}
      </div>
      <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: 17, fontWeight: 700, color: 'var(--dark)', margin: '0 0 6px' }}>{programme.name}</h3>
      <p style={{ fontSize: 13, color: 'var(--dark-60)', margin: '0 0 18px', lineHeight: 1.55 }}>{programme.description}</p>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontSize: 13, color: 'var(--dark-40)' }}>{programme.courses.length} course{programme.courses.length !== 1 ? 's' : ''}</span>
        {onClick && (
          <span style={{ display: 'flex', alignItems: 'center', gap: 4, color: programme.color, fontSize: 13, fontWeight: 700, fontFamily: 'var(--font-heading)' }}>
            View <Icon name="chevronRight" size={13} color={programme.color} />
          </span>
        )}
      </div>
    </div>
  );
}

export function CourseCard({ course, programmeColor }) {
  return (
    <div style={{ background: 'var(--white)', border: '1.5px solid var(--dark-10)', borderRadius: 'var(--radius-lg)', padding: 20, opacity: course.placeholder ? 0.7 : 1, display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 10, gap: 8 }}>
        <Badge bg={programmeColor + '18'} color={programmeColor}>{course.category}</Badge>
        <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
          {course.placeholder && <Badge bg="var(--warning-soft)" color="var(--warning)">Coming soon</Badge>}
          {course.studentCount && <span style={{ fontSize: 12, color: 'var(--dark-40)', fontWeight: 500 }}>{course.studentCount} students</span>}
        </div>
      </div>
      <h4 style={{ fontFamily: 'var(--font-heading)', fontSize: 15, fontWeight: 700, color: 'var(--dark)', margin: '0 0 6px' }}>{course.name}</h4>
      <p style={{ fontSize: 13, color: 'var(--dark-60)', margin: '0 0 18px', lineHeight: 1.55, flex: 1 }}>{course.description}</p>
      <div>
        {course.link ? (
          <Button size="sm" onClick={() => window.open(course.link, '_blank')} style={{ background: programmeColor }}>
            <Icon name="external" size={13} color="white" /> Launch
          </Button>
        ) : (
          <Button size="sm" variant="secondary" disabled={course.placeholder}>
            <Icon name="lock" size={13} color="var(--dark-40)" />
            {course.placeholder ? 'Link pending' : 'No link'}
          </Button>
        )}
      </div>
    </div>
  );
}
